const host = window.location.hostname;

const getAppEnv = () => {
  if (host === 'localhost' || host.includes('bs-local')) return 'int';

  if (host.endsWith('int.uefa.com')) return 'int';
  if (host.endsWith('pre.uefa.com')) return 'pre';

  return 'prod';
};

export const appEnv = getAppEnv();
